import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';

// List of 5-letter finance-related words
const financeWords = [
  "money", "bonds", "asset", "yield", "price", "coins", "spend", "loans", "stock",
  "funds", "rates", "check", "debit", "audit", "taxes", "trade", "bills", "bulls", "bears",
  "index", "value", "share", "banks", "risks", "gains", "wages", "debts", "quote", "offer",
  "bucks", "bonus", "limit", "proxy", "score", "trust", "costs", "saver", "sales", "goods",
  "chart", "draft", "firms", "merge", "model", "ratio", "range", "close", "gross", "basic", "total",
];

const Financle = () => {
  const [wordOfTheDay, setWordOfTheDay] = useState("");
  const [userInput, setUserInput] = useState("");
  const [feedback, setFeedback] = useState([]);
  const [attempts, setAttempts] = useState(0);
  const [isCorrect, setIsCorrect] = useState(false);
  const maxAttempts = 6;

  // Function to calculate the word of the day
  const calculateWordOfTheDay = () => {
    const today = new Date();
    const dayIndex = today.getDate() % financeWords.length; // Rotate through the list
    setWordOfTheDay(financeWords[dayIndex]);
  };

  // Effect to set the word of the day when the component loads
  useEffect(() => {
    calculateWordOfTheDay();
  }, []);

  // Handle user input changes
  const handleInputChange = (e) => {
    setUserInput(e.target.value.toLowerCase());
  };

  // Handle guess submission
  const handleSubmit = (e) => {
    e.preventDefault();
    if (userInput.length !== 5) return; // Ensure input is 5 letters

    if (userInput === wordOfTheDay) {
      setIsCorrect(true);
    }

    const hint = generateHint(userInput, wordOfTheDay);
    setFeedback([...feedback, { guess: userInput, hint }]);
    setAttempts(attempts + 1);
    setUserInput(""); // Reset input
  };

  // Generate a hint for the user's guess
  const generateHint = (guess, target) => {
    const hint = [];
    const targetArray = target.split("");
    const guessArray = guess.split("");

    // Track letters already matched to avoid double-counting
    const matchedLetters = Array(target.length).fill(false);

    // First pass: check for correct letters in the correct position (green)
    guessArray.forEach((char, index) => {
      if (char === targetArray[index]) {
        hint.push({ letter: char, color: "green" });
        matchedLetters[index] = true; // Mark as matched
      } else {
        hint.push({ letter: char, color: "" }); // Placeholder, color will be updated in the second pass
      }
    });

    // Second pass: check for correct letters in the wrong position (yellow)
    guessArray.forEach((char, index) => {
      if (hint[index].color === "") {
        const wrongPositionIndex = targetArray.findIndex(
          (targetChar, targetIndex) =>
            targetChar === char && !matchedLetters[targetIndex]
        );

        if (wrongPositionIndex !== -1) {
          hint[index].color = "yellow";
          matchedLetters[wrongPositionIndex] = true; // Mark as matched
        } else {
          hint[index].color = "gray"; // Incorrect letter
        }
      }
    });

    return hint;
  };

  return (
    <Container style ={{ marginTop: '40px'}}>
      <Row>
        <Col>
          <h3 className="mb-3">Financle - Finance Wordle</h3>
          <p>Guess the 5-letter finance word of the day! You only get 6 guesses, so guess wisely.</p>

          {isCorrect ? (
            <div className="alert alert-success">
              🎉 Congratulations! You guessed the word: <strong>{wordOfTheDay}</strong>
            </div>
          ) : attempts < maxAttempts ? (
            <Form onSubmit={handleSubmit}>
              <Form.Group controlId="guessInput">
                <Form.Label>Enter your guess (5 letters):</Form.Label>
                <Form.Control
                  type="text"
                  value={userInput}
                  onChange={handleInputChange}
                  disabled={isCorrect}
                  maxLength={5}
                  placeholder="Guess a 5-letter word"
                />
              </Form.Group>
              <Button type="submit" className="mt-2" style={{ backgroundColor: '#4CAF50' }} disabled={userInput.length !== 5}>
                Submit Guess
              </Button>
            </Form>
          ) : (
            <div className="alert alert-danger">
              You have reached the maximum number of attempts. The word was: <strong>{wordOfTheDay}</strong>
            </div>
          )}

          <div className="mt-4 d-flex justify-content-center flex-column align-items-center">
            {feedback.map((entry, index) => (
              <div key={index} className="d-flex gap-2 mb-2">
                {entry.hint.map((hintItem, hintIndex) => (
                  <span
                    key={hintIndex}
                    style={{
                      display: "inline-block",
                      width: "40px",
                      height: "40px",
                      lineHeight: "40px",
                      textAlign: "center",
                      borderRadius: "5px",
                      backgroundColor:
                        hintItem.color === "green"
                          ? "#6aaa64"
                          : hintItem.color === "yellow"
                          ? "#c9b458"
                          : "#787c7e",
                      color: "white",
                      fontWeight: "bold",
                    }}
                  >
                    {hintItem.letter.toUpperCase()}
                  </span>
                ))}
              </div>
            ))}
          </div>

          <p className="mt-4">
            <strong>Attempts:</strong> {attempts}
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default Financle;